import { forwardRef, createElement } from 'react';

function IconCalendar(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M16.25 2c.414 0 .75.294.75.656V3h2.25c.966 0 1.75.83 1.75 1.853v14.294C21 20.17 20.216 21 19.25 21H4.75C3.784 21 3 20.17 3 19.147V4.853C3 3.83 3.784 3 4.75 3H7v-.344C7 2.294 7.336 2 7.75 2s.75.294.75.656V3h7v-.344c0-.362.336-.656.75-.656zm3.25 6h-15v11.147c0 .125.082.23.193.258l.057.007h14.5a.254.254 0 00.243-.204l.007-.06V8zm-11 7a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2zm4.5 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2zm4.5 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2zm-9-4.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2A.5.5 0 016 12v-1a.5.5 0 01.5-.5h2zm4.5 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2zm4.5 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2zM7 4.588H4.75a.254.254 0 00-.243.204l-.007.06V6.5h15V4.853a.262.262 0 00-.193-.258l-.057-.007H17v.256c0 .362-.336.656-.75.656s-.75-.294-.75-.656v-.256h-7v.256c0 .362-.336.656-.75.656S7 5.206 7 4.844v-.256z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Calendar = /*#__PURE__*/forwardRef(IconCalendar);

export default Calendar;
//# sourceMappingURL=Calendar.js.map
